export default __webpack_public_path__ + "static/media/nz.540037b9.png";